import { Box, Checkbox, CircularProgress, Typography } from "@mui/material";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import StyledCartCards from "./StyledCartCards";
import { SHOPPING_CART_MODAL } from "../../../constants/lang";
import { getFormattedDate } from "../../../utils/commonFuntions";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const TripDetailsCard = ({ tripDetails,
  selectedTrip,
  setSelectedTrip, loadingTripDetails, setIsFormOpen }) => {

  if (!loadingTripDetails && !tripDetails?.id) {
    return null
  }

  const handleTripChange = () => {
    if (selectedTrip === null) {
      setSelectedTrip(tripDetails?.id)
    } else {
      setSelectedTrip(null)
    }
  }

  return (
    <StyledCartCards>
      {loadingTripDetails && <CircularProgress size={16} className="loading-spinner-1" />}
      <Box
        className="trip-details"
      >
        <Box className="box-container">
          <MapsHomeWorkOutlinedIcon className="box-icon" />
          <Box>
            <Typography className="details">
              {tripDetails?.hotel_name ? tripDetails?.hotel_name + "," :
                <Typography onClick={() => setIsFormOpen()} className="details-1" display="inline">
                  {SHOPPING_CART_MODAL.headings.addHotel},
                </Typography>}
              {tripDetails?.city_name ? tripDetails?.city_name :
                <Typography onClick={() => setIsFormOpen()} className="details-1" display="inline">
                  {SHOPPING_CART_MODAL.headings.addcity}
                </Typography>}
            </Typography>
            <Typography className="date-details">
              {tripDetails?.arrival_date ?
                getFormattedDate(tripDetails?.arrival_date) :
                <Typography onClick={() => setIsFormOpen()} className="details-1" display="inline">
                  {SHOPPING_CART_MODAL.headings.addArrivalDate}
                </Typography>}
            </Typography>
          </Box>
        </Box>

        {(tripDetails?.hotel_name?.length && tripDetails?.city_name?.length && tripDetails?.arrival_date?.length) ?
          <Checkbox onClick={() => handleTripChange()} checked={selectedTrip} className="checkbox-custom" /> :
          <EditOutlinedIcon onClick={() => setIsFormOpen()} className="edit-icon" />}
      </Box>
    </StyledCartCards>
  )
}

export default TripDetailsCard;